import { render, staticRenderFns } from "./myTraining.vue?vue&type=template&id=106a9ee6&scoped=true"
import script from "./myTraining.vue?vue&type=script&lang=js"
export * from "./myTraining.vue?vue&type=script&lang=js"
import style0 from "./myTraining.vue?vue&type=style&index=0&id=106a9ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a9ee6",
  null
  
)

export default component.exports